import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Alerta "nova mensagem no chat de suporte". Leva direto a conversa; o nome de
 * quem enviou vem de content() (data).
 */
export default class MarketplaceMessageNotification extends Notification {
  icon() {
    return 'fas fa-comments';
  }
  href() {
    const data = this.attrs.notification.content() ?? {};
    return app.route('marketplace.conversation', {
      id: data.conversation_id
    });
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.new_message', {
      sender: data.sender_name
    });
  }
  excerpt() {
    const data = this.attrs.notification.content() ?? {};
    return data.sender_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/MarketplaceMessageNotification', MarketplaceMessageNotification);